import { render, staticRenderFns } from "./CastingDetail.vue?vue&type=template&id=370b0dd6"
import script from "./CastingDetail.vue?vue&type=script&lang=js"
export * from "./CastingDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports